import BaneadosService from '@/services/baneados.services';
import { _ } from 'vue-underscore';
import toastr from 'toastr';

export default {
    name: 'Comparacion',
    props: ['comparadores','actions'],
    data() {
        return {
            loading: false,
            generals: {
                data: [],
                tmp: [],
                pagination: {
                    pag: 3,
                    currentPage: 1
                }
            },
            send: {
                descripComparacion: ''
            },
            keyword: [],
            btndisable: true
        }
    },
    created() {
        //this.get();
    },
    watch: {
        send: {
            deep: true,
            handler() {
                if (_.contains(this.keyword, this.send.descripComparacion.trim().toLowerCase()) || this.send.descripComparacion.trim().length == 0) {
                    this.btndisable = true;
                } else {
                    this.btndisable = false;
                }
            }
        },
        comparadores: {
            deep: true,
            handler(data) {
                this.generals.data = data;
                this.paginationFilter(this.generals.data, this.generals.pagination.currentPage);
                this.keyword = _.map(this.generals.data, (map) => { return map.comparacion.trim().toLowerCase(); });
                this.loading = false;
            }
        },
        'generals.pagination.currentPage': {
            handler(data) {
                this.paginationFilter(this.generals.data, data);
            }
        }
    },
    methods: {
        get() {
            this.loading = true;
            BaneadosService.comparacion.getAll().then((response) => {
                this.generals.data = response.data;
                this.paginationFilter(this.generals.data, 0);
                this.keyword = _.map(this.generals.data, (map) => { return map.comparacion.trim().toLowerCase(); });
                this.loading = false;
            }).catch((error) => {
                this.loading = false;
                console.log(error.response.data);
            });
        },
        add() {
            BaneadosService.comparacion.add(this.send).then((response) => {
                this.get();
                sysMsgs.getMessage('Registro agregado con éxito.','success');
                this.send.descripComparacion = '';
            }).catch((error) => {
                console.log(error.response.data);
                sysMsgs.getMessage('Ha ocurrido un error: ' + error.response.data,'error');
            });
        },
        remove(data) {
            BaneadosService.comparacion.remove(data).then((response) => {
                this.get();
                sysMsgs.getMessage('Registro eliminado con éxito.','warning');
            }).catch((error) => {
                console.log(error.response.data);
                sysMsgs.getMessage('Ha ocurrido un error: ' + error.response.data,'error');
            });
        },
        verifyKeyword() {
            console.log(this.keyword);
        },
        update(data) {
            console.log(data);
            /*  BaneadosService.tipo.remove(data).then((response) => {
                 this.get();
              }).catch((error) => {
                  console.log(error.response.data);
              }); */
        },
        paginationFilter(data, start) {
            start = start - 1;
            this.generals.tmp = data.slice(
                this.generals.pagination.pag * start,
                this.generals.pagination.pag * start + this.generals.pagination.pag
            );
        }
    }
}